module.exports = __webpack_public_path__ + "static/img/wealth_level_62.0b9fb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_62.png
// module id = UWQ/
// module chunks = 0